// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__gYqpp","description--expanded":"Description_description--expanded__zdTU6"};